module.exports = __webpack_public_path__ + "img/outsourcing-company-vs-recruiting-agency.570e7fd6.jpeg";